import { useEffect, useState } from "react";
import styled from "styled-components";
import { useMouseStore } from "../../../hooks/stores/mouseStore";
import { MenuItem } from "../../views/TopbarMenu";
import { MenubarContent } from "./MenubarContent";
import { MenubarItemSeparator } from "./MenubarItemSeparator";
import { MenubarSubmenu } from "./MenubarSubmenu";
import { MenubarTrigger } from "./MenubarTrigger";

export const DropdownMenu = ({
  data
}: {
  data: MenuItem[]
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);

  const closeMenu = () => {
    setOpenIndexes([]);
    setIsMenuOpen(false);
  };

  return <Container onMouseEnter={() => setIsMouseOver(true)} onMouseLeave={() => setIsMouseOver(false)}>
    {data.map((menuItem, triggerIndex) => (
      <TriggerContainer key={`menu-trigger-${triggerIndex}`}>
        {menuItem.label !== undefined && <MenubarTrigger
          isActive={openIndexes[0] === triggerIndex}
          isDisabled={menuItem.isDisabled}
          cursorPointer={menuItem.items ? false : true}
          onClick={() => {
            menuItem.onClick && menuItem.onClick();
            setIsMenuOpen((isOpen) => {
              if (isOpen) {
                setOpenIndexes([]);
                return false;
              }
              if (menuItem.items) {
                setOpenIndexes([triggerIndex]);
                return true;
              }
              return isOpen;
            });
          }}
          onMouseEnter={() => menuItem.items && isMenuOpen && setOpenIndexes([triggerIndex])}
        >
          {menuItem.label}
        </MenubarTrigger>}

        {menuItem.items && (
          <MenubarContent $isOpen={openIndexes[0] === triggerIndex || menuItem.label === undefined} $bottom>
            {menuItem.items?.map((subMenuItem, itemIndex) =>
              subMenuItem.separator ? (
                <MenubarItemSeparator key={`separator-${triggerIndex}-${itemIndex}`} />
              ) : (
                <MenubarSubmenu
                  key={`menu-${triggerIndex}-${itemIndex}`}
                  item={subMenuItem}
                  index={itemIndex}
                  depth={1}
                  openIndexes={openIndexes}
                  setOpenIndexes={setOpenIndexes}
                  closeMenu={closeMenu}
                  isDisabled={subMenuItem.isDisabled}
                />
              )
            )}
          </MenubarContent>
        )}
      </TriggerContainer>
    ))}

    <CloseHook isMouseOver={isMouseOver} closeMenu={closeMenu} />
  </Container>
}

// To avoid unnecessary rerenders
const CloseHook = ({ isMouseOver, closeMenu }: { isMouseOver: boolean; closeMenu: () => void }) => {
  const [mouseData] = useMouseStore();
  useEffect(() => {
    if (mouseData.isDown && !isMouseOver) {
      closeMenu();
    }
  }, [mouseData.isDown]);

  return null;
};


const Container = styled.div`
  user-select: none;
  display: flex;
  gap: 2px;

  font-family: var(--font-1);
  font-size: 12px;
`;

const TriggerContainer = styled.div`
  position: relative;
`;
